'use strict';

define(['app', 'componentHelper', '$console'], function (app, componentHelper, $console) {

  var responsiveFlyoutBasket = function responsiveFlyoutBasket() {
    var component = {};

    var _config = {
      selectors: {
        deviceStateEl: '[data-device-state]',
        continueShoppingButton: '[data-close-basket]',
        openFlyoutPanel: '[data-js-element=responsiveFlyoutBasket_openFlyoutPanel]',
        checkbox: '[data-js-element=responsiveFlyoutBasket_checkbox]',
        basketSummary: '[data-js-element=responsiveFlyoutBasket_basketSummary]',
        basketItems: '[data-scroll]'
      },
      classNames: {
        basketSummaryShadowClass: 'responsiveFlyoutBasket_basketSummary-shadow'
      }
    };

    var _init = function _init(element) {
      component.element = element;

      component.deviceStateEl = component.element.querySelector(component.config.selectors.deviceStateEl);
      component.deviceState = window.getComputedStyle(component.deviceStateEl, ':before').getPropertyValue('content').replace(/\"/g, '');
      component.continueShoppingButton = component.element.querySelectorAll(component.config.selectors.continueShoppingButton);
      component.openFlyoutPanel = component.element.querySelector(component.config.selectors.openFlyoutPanel);
      component.checkbox = component.element.querySelector(component.config.selectors.checkbox);
      component.basketSummary = component.element.querySelector(component.config.selectors.basketSummary);
      component.basketItemsContainer = component.element.querySelector(component.config.selectors.basketItems);

      app.subscribe('ajaxBasket/updateGlobalBasketItemsCount', component.ajaxBasketItems);
      app.subscribe('globalBasketItemsCount/updateGlobalBasketItemsCount', component.ajaxBasketItems);

      component.bind();

      return component;
    };

    var _bind = function _bind() {
      if (component.continueShoppingButton) {
        Array.from(component.continueShoppingButton).map(function (el) {
          return el.addEventListener('click', component.closeBasket);
        });
      }

      if (component.basketItemsContainer) {
        component.basketItemsContainer.addEventListener('scroll', component.addRemoveShadow);
      }

      component.deviceStateCondition(component.deviceState);
      window.addEventListener('resize', component.resizeEvent);
    };

    var _resizeEvent = function _resizeEvent() {
      var state = window.getComputedStyle(component.deviceStateEl, ':before').getPropertyValue('content').replace(/\"/g, '');

      component.deviceStateCondition(state);
    };

    var _deviceStateCondition = function _deviceStateCondition(state) {
      if (!component.basketItemsContainer) {
        return;
      }

      if (state === 'desktop') {
        component.openFlyoutPanel.addEventListener('mouseenter', component.resetScrollPosition);
      } else {
        component.openFlyoutPanel.removeEventListener('mouseenter', component.resetScrollPosition);
      }
    };

    var _scrollPosition = function _scrollPosition() {
      return component.basketItemsContainer.scrollTop;
    };

    var _addRemoveShadow = function _addRemoveShadow() {

      if (component.scrollPosition() > 5) {
        component.basketSummary.classList.add(component.config.classNames.basketSummaryShadowClass);
      } else {
        component.basketSummary.classList.remove(component.config.classNames.basketSummaryShadowClass);
      }
    };

    var _closeBasket = function _closeBasket() {
      component.checkbox.click();
      if (component.basketItemsContainer) {
        component.resetScrollPosition();
      }
    };

    var _resetScrollPosition = function _resetScrollPosition() {
      component.basketItemsContainer.scrollTop = 0;
    };

    var _ajaxBasketItems = function _ajaxBasketItems() {
      app.ajax.get({
        url: '/responsiveFlyoutBasket.bsk',
        dataType: 'JSON',
        success: component.updateBasketItems,
        error: component.updateBasketItemsError
      });
    };

    var _updateBasketItems = function _updateBasketItems(response) {
      var parent = component.element.parentElement;
      if (parent) {
        parent.innerHTML = response;
        componentHelper.reloadAllComponents(parent);
      }
    };

    var _updateBasketItemsError = function _updateBasketItemsError(response) {
      $console.error(response);
    };

    component.config = _config;
    component.init = _init;
    component.bind = _bind;
    component.resizeEvent = _resizeEvent;
    component.deviceStateCondition = _deviceStateCondition;
    component.addRemoveShadow = _addRemoveShadow;
    component.closeBasket = _closeBasket;
    component.resetScrollPosition = _resetScrollPosition;
    component.ajaxBasketItems = _ajaxBasketItems;
    component.updateBasketItems = _updateBasketItems;
    component.updateBasketItemsError = _updateBasketItemsError;
    component.scrollPosition = _scrollPosition;

    return component;
  };

  return responsiveFlyoutBasket;
});
//# sourceMappingURL=responsiveFlyoutBasket.js.map
